<template>
  <div style="border-radius: 8px" class="row">
    <div class="row">
      <div class="card p-2 pb-0 filter col-md-12">
        <div class="row w-100 pe-lg-0 me-1 py-2">
          <div class="col-md-3 col-12">
            <div class="mb-1">
              <label for="quantity">Quantity</label>
              <input v-model="sticker.quantity" class="form-control" id="quantity" type="number"/>
            </div>
          </div>
          <div class="col-md-3 col-12">
            <div class="mb-1">
              <button @click="goToPrint" class="btn btn-primary mt-1">Print</button>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div id="section-to-print">
            <div class="row gap-1">
              <div v-for="index in barcodeQty" :key="index" class="sticker-border text-center loop-dev">
                <div class="l-height">
                  <span class="text-label">{{ route.params.barcodeSku }}</span>
                  <div class="barcode-img" v-html="barcode"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { computed, onMounted, ref } from "vue";
import {useRoute} from "vue-router";
import handleBarcode from "@/services/modules/barcode";
import { printBarcodes } from '@/services/utils/pdf/barcodePrint.js';

const { fetchBarcode } = handleBarcode();
const route = useRoute();

const barcodeQty = computed(() => parseInt(sticker.value.quantity));

let barcode = ref(null);
let sticker = ref({
  quantity: 1,
});

const getBarCode = (code) => {
  fetchBarcode(`?code=${code}&width=1.5&height=40`).then((res) => {
    barcode.value = res.barcode;
  })
}

onMounted(() => {
  if (route.params.barcodeSku) {
    getBarCode(route.params.barcodeSku)
  }
})

const goToPrint = () => {
  printBarcodes({
    barcodeHtml: barcode.value,
    quantity: parseInt(sticker.value.quantity),
    text: route.params.barcodeSku,
  });
}
</script>

<style>
.text-center {
  text-align: center;
}

.loop-dev {
  height: auto;
  padding-bottom: 5px;
  margin-bottom: 10px;
  line-height: 1.0000in;
  width: 1.5in !important;
  display: block;
}

.text-label {
  font-size: 14px;
  display: block;
  margin: 3px
}

/*Css related to printing of barcode*/
.label-border-outer {
  line-height: 16px;
  page-break-after: always;
  border: 0.1px solid grey !important;
}

.label-border-internal {
  margin: 24px;
}

.sticker-border {
  border: 0.1px dotted grey !important;
  overflow: hidden;
  box-sizing: border-box;
}

.barcode-img svg {
  width: 100% !important;
  height: auto !important;
}

.fixed-width-name {
  width: 140px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.l-height {
  line-height: 15px;
}
</style>
